import "./Demo.module.css";
import Header from "@/reusable_sections/Header";
import DemoHero from "./sections/DemoHero";
import DemoVideos from "./sections/DemoVideos";
import RequestCustomDemoSection from "./sections/RequestCustomDemoSection";
import Footer from "@/reusable_sections/Footer";
export default function DemoPage() {
  return <div>
      <Header />
      <DemoHero />
      <DemoVideos />
      <RequestCustomDemoSection />
      <Footer />
    </div>;
}